import config from '../../config/generated.json'

function getFooterLogoPath(): string {
  return config.filePaths.logo.footer
}

export default getFooterLogoPath
